"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isIsoDateOnlyString = exports.IsoDateOnlyStringSchema = exports.isIsoDateString = exports.IsoDateStringSchema = void 0;
const luxon_1 = require("luxon");
const z = __importStar(require("zod"));
const type_validation_helpers_1 = require("../helpers/type_validation_helpers");
// Accepted formats:
// 2021-09-19
// 2021-09-19T08:14:05Z or 2021-09-19T08:14:05.000Z
// 2021-09-19T08:14:05+00:00 or 2021-09-19T08:14:05.000+00:00
exports.IsoDateStringSchema = z
    .string()
    .refine((val) => luxon_1.DateTime.fromISO(val).isValid);
exports.isIsoDateString = type_validation_helpers_1.getTypeValidationFunction(exports.IsoDateStringSchema);
const dateOnlyRegex = new RegExp(/^\d{4}-\d{2}-\d{2}$/); // 2021-09-19
exports.IsoDateOnlyStringSchema = exports.IsoDateStringSchema.refine((val) => dateOnlyRegex.test(val));
exports.isIsoDateOnlyString = type_validation_helpers_1.getTypeValidationFunction(exports.IsoDateOnlyStringSchema);
//# sourceMappingURL=iso_date_string_types.js.map